<!--新增、修改用户弹窗-->
<template>
    <el-dialog append-to-body :close-on-press-escape="false" :modal-append-to-body="false" :close-on-click-modal="false" :title="titleUser" :visible.sync="dialogFormVisible" width="800px">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="用户信息" name="first">
                <h3 style="font-size: 14px;padding: 0 0 10px 25px;">用户信息</h3>
                <el-form v-if="dialogFormVisible" :model="formSave" ref="formSaveRef" label-width="80px" label-position="right" :rules="rules">
                    <el-row>
                        <el-col :span="12">
                            <div class="grid-content bg-purple">
                                <el-form-item label="品牌 : " required>
                                    <el-select v-model="formSave.brandIdentify" @change="brandSeclectChange" :disabled="operType == 'update'" placeholder="请选择品牌"
                                               style="width:85%">
                                        <el-option v-for="item in brandOptions"
                                                   :key="item.brandId"
                                                   :label="item.brandName"
                                                   :value="item.brandIdentify">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="grid-content bg-purple-light">
                                <el-form-item label="登录名 : " prop="account">
                                    <el-input v-model="formSave.account" autocomplete="off"
                                              :disabled="operType == 'update'" placeholder="请输入英文姓名"
                                              style="width: 85%"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <div class="grid-content bg-purple">
                                <el-form-item label="子品牌 : " prop="brandList">
                                    <el-select v-model="formSave.brandList" multiple placeholder="请选择子品牌"
                                               style="width:85%">
                                        <el-option v-for="item in sonBrandOptions"
                                                   :key="item.brandId"
                                                   :label="item.brandName"
                                                   :value="item.brandIdentify">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="grid-content bg-purple-light">
                                <el-form-item label="手机号 : " prop="contactInfo">
                                    <el-input v-model="formSave.contactInfo" autocomplete="off"
                                              placeholder="请输入手机号"
                                              style="width: 85%"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <div class="grid-content bg-purple">
                                <el-form-item label="昵称 : " prop="nickname">
                                    <el-input v-model="formSave.nickname" autocomplete="off" placeholder="请输入昵称"
                                              style="width: 85%"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="grid-content bg-purple-light">
                                <el-form-item label="邮箱 : " prop="email">
                                    <el-input v-model="formSave.email"
                                              placeholder="请输入邮箱"
                                              style="width: 85%"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <div class="grid-content bg-purple">
                                <el-form-item label="密码 : " prop="password">
									<el-input v-model="formSave.password" style="width: 0"></el-input>
                                    <el-input v-model="formSave.password"
                                              :disabled="!needPassword && operType == 'update'"
                                              placeholder="请输入密码"
                                              show-password
                                              auto-complete="new-password"
                                              style="width: 85%"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="grid-content bg-purple-light">
                                <el-form-item label="确认密码 : " prop="ensurepassword">
                                    <el-input v-model="formSave.ensurepassword"
                                              :disabled="!needPassword && operType == 'update'"
                                              placeholder="请再次输入密码"
                                              show-password
                                              auto-complete="new-password"
                                              style="width: 85%"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <div class="grid-content bg-purple-light">
                                <el-form-item label="角色 : " prop="roleList">
                                    <el-select v-model="formSave.roleList" :disabled="
                                        !canChangeRole(formSave.userType)
                                    " multiple collapse-tags placeholder="请选择用户角色" style="width:85%">
                                        <el-option-group
                                          v-for="group in roulelist"
                                          :key="group.label"
                                          :label="group.label">
                                          <el-option v-for="item in group.options"
                                               :key="item.roleId"
                                               :label="item.roleName"
                                               :value="item.roleId">
                                        </el-option>
                                        </el-option-group>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="grid-content bg-purple-light">
                                <el-form-item label="用户类型 : " required>
                                    <el-select v-model="formSave.userType" :disabled="
                                        userInfo.userId == formSave.userId ||
                                        userInfo.userType != '1'
                                    " placeholder="请选择用户类型" style="width:85%">
                                        <el-option v-for="item in userTypeOptions"
                                                   :key="item.userTypeId"
                                                   :label="item.userTypeName"
                                                   :value="item.userTypeValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>

					<el-row>
                        <el-col :span="12">
                            <div class="grid-content bg-purple-light">
                                <el-form-item label="群组 : " prop="groupList">
                                    <el-cascader v-model="formSave.groupList" :props="props" :options="groupList" :collapse-tags="true" filterable clearable style="width:85%"></el-cascader>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="grid-content bg-purple">
                                <el-form-item label="ppn账号: " prop="ppnUsername">
                                    <el-input v-model="formSave.ppnUsername" autocomplete="off" placeholder="请输入ppn账号"
                                              style="width: 85%"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row v-if="operType == 'update'">
						<el-col :span="12">
                            <div class="grid-content bg-purple">
                                <el-form-item required label="状态 : ">
                                    <el-radio-group v-model="formSave.state">
                                        <el-radio name='type' label="0">正常</el-radio>
                                        <el-radio name='type' label="1">锁定</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="grid-content bg-purple">
                                <el-form-item label="修改密码 : ">
                                    <el-radio-group v-model="needPassword" @change="changePasswordSelect">
                                        <el-radio name="type" :label="true">是</el-radio>
                                        <el-radio name="type" :label="false">否</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="电话权限" name="second" v-if="lark_switch_url && isPapulad && userInfo.brandIdentify != 'relx'">
                <TelRole v-if="activeName === 'second'" :data="current_row" @getCancelBtn="getCancelBtn" @createCB="changeThirdTab"/>
            </el-tab-pane>
            <el-tab-pane label="IM权限" name="third" v-if="isPapulad && userInfo.brandIdentify != 'relx'">
                <im-role v-if="activeName === 'third'" :data="current_row" @getCancelBtn="getCancelBtn" @updateImRole="updateImRole"></im-role>
            </el-tab-pane>
        </el-tabs>

        <div slot="footer" class="dialog-footer" v-if="activeName == 'first'">
            <el-button @click="getCancelBtn()">取 消</el-button>
            <el-button type="primary" @click="commit" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import {
    validateAccount,
    validateNickname,
    validateMobile,
    validateEmail,
    validatePassword
} from "@/utils/validator";
import {
    isPassword
} from "@/utils/validate";

import TelRole from './telRole.vue'
import imRole from './imRole.vue'
import { Encrypt } from '@/utils/crypto'

export default{
	name: "userUpdate",
	components: {
		TelRole,
		imRole
	},
	data(){
        const validatePassword = (rule, value, callback) => {
            if(!this.needPassword){
                callback();
            }
            if(!value){
                callback(new Error('请输入密码'))
            }else if (!isPassword(value)) {
                callback(new Error('密码需包含写字母特殊符号数字且不少于8位'));
            } else {
                callback();
            }
        };
        const validateSamePassword = (rule, value, callback) => {
            if(!this.needPassword){
                callback();
            }
            if(!value){
                callback(new Error('请确认密码'))
            }else if (value!== this.formSave.password) {
                callback(new Error('两次输入密码不一致'));
            } else {
                callback();
            }
        };
        const validateRole = (rule, value, callback) => {
            if(value.length <= 0){
                callback(new Error('请选择角色'))
            } else {
                callback();
            }
        };
		const validateGroup = (rule, value, callback) => {
            if(value.length <= 0){
                callback(new Error('请选择群组'))
            } else {
                callback();
            }
        };
		let id = 0;
		return {
            loading: false,
			dialogFormVisible: false,
			activeName: 'first',
			ensuerpassword: "",
			formSave: {
                account: "",
                agentCode: "",
                bossId: "",
                brandIdentify: "",
                brandList: [],
                contactInfo: "",
                createBy: "",
                createTime: "",
                email: "",
                ensurepassword: "",
                headImg: "",
                isDeleted: false,
                menuList: [],
                nickname: "",
				ppnUsername: "",
                password: "",
                roleList: [],
                state: "0",
                tsAccount: "",
                userId: "",
                userSite: "",
                userType: "",
                worktimeType: "",
				groupList: []
            },
            current_row: "",
            titleUser: "新增用户",
            // 品牌选项
            brandOptions: [],
            // 子品牌选项
            sonBrandOptions: [],
            operType: "",
            needPassword: true,
            roulelist: [],
			groupList: [],
            userTypeOptions: [{
                userTypeId: '0',
                userTypeName: '普通用户',
                userTypeValue: '0'
            }, {
                userTypeId: '2',
                userTypeName: '品牌管理员',
                userTypeValue: '2'
            }, {
                userTypeId: '1',
                userTypeName: '管理员(仅限Majorel内部使用)',
                userTypeValue: '1'
            }],
            // 是否显示tab选择
            isPapulad: false,
            rules: {
                brandList: [{ required: true , validator: (rule, value, callback) => {
                    if (value.length < 1) {
                        callback(new Error('请选择子品牌'));
                    } else {
                        callback();
                    }
                },trigger: 'blur' }],
                account: [{ required: true, validator: validateAccount, trigger: 'blur' }],
                contactInfo: [{ required: false, validator: validateMobile, trigger: 'blur' }],
                email: [{ required: false, validator: validateEmail, trigger: 'blur' }],
                nickname: [{ required: true, validator: validateNickname, trigger: 'blur' }],
                password: [{ required: true, validator: validatePassword, trigger: 'blur' }],
                ensurepassword: [{ required: true, validator: validateSamePassword, trigger: 'blur' }],
                roleList: [{ required: true, validator: validateRole, trigger: ['blur',"change"] }],
            },
			props: {
				multiple: true,
				checkStrictly: true,
				emitPath: false,
				label: 'groupName',
				value: 'groupId'
			},
		}
	},
	computed: {
		...mapGetters([
            'userInfo',
			'lark_switch_url'
        ]),
	},
    watch: {
        "formSave.brandIdentify": function (val, oldVal) {
            this.sonGetBrandListBtn(val);
            this.getRoleList(this.userInfo.userType == 1?val:this.userInfo.brandIdentify);
			this.getGroupList(this.userInfo.userType == 1?val:this.userInfo.brandIdentify);
        },
        operType: function(){
            this.setFormState();
        },
        needPassword: function(){
            this.rules.password[0].required = this.needPassword;
            this.rules.ensurepassword[0].required = this.needPassword;
        }
    },
	created() {
	},
	methods: {
        changeThirdTab() {
            console.log("third")
            this.activeName = "third";
        },
		getGroupList(brandIdentify) {
			if(!brandIdentify) {
				return;
			}
			this.$api.apiGetGroupList(brandIdentify).then(response => {
				if(response.errcode != 0) {
					return;
				}
				this.groupList = this.translateDataToTree(response.data || []);
			});
		},
		translateDataToTree(data, parentGroupId = null) {
			const self = this;
			let tree = [];
			let temp;
			data.forEach((item, index) => {
				if (data[index].parentGroupId == parentGroupId) {
					let obj = data[index];
					temp = self.translateDataToTree(data, data[index].groupId);
					if (temp?.length > 0) {
						obj.children = temp;
					}
					tree.push(obj);
				}
			})
			return tree;
		},
		init(){
			this.getBrandListBtn();
			this.getRoleList();
		},
		handleClick(tab, event) {
            if (tab.index == "0") {
                this.titleUser = "修改用户"
            } else if (tab.index == "1") {
                this.titleUser = "电话权限"
            } else {
                this.titleUser = "IM权限"
            }
        },
        changePasswordSelect(val) {
            if (val == false) {
                this.formSave.password = null
                this.formSave.ensurepassword = null
            }
        },
        //更新话务员信息
        updateImRole() {
           this.dialogFormVisible = false;
           this.resetFormData();
        },
        brandSeclectChange (value) {
            this.formSave.roleList = [];
            this.formSave.brandList = [];
			this.formSave.groupList = [];
        },
        // 是否可以修改角色
        canChangeRole(formUserType){
            return formUserType == 0 || this.userInfo.userType == 1;
        },
		// 获取品牌下拉项
		getBrandListBtn(query) {
		    this.$api.getBrandSelist({
		        data: {
		            // brandIdentify: this.queryInfo.brandIdentify,
		            brandName: ""
		        },
		        orderBy: '',
		        pageNum: 1,
		        pageSize: 50
		    }).then(res => {
		        // console.log("品牌列表",res)
		        this.brandOptions = res.list
		    })
		},
		// 获取子品牌下拉项
        sonGetBrandListBtn(parentBrandIdentify) {
            this.$api.getBrandSelist({
                data: {
                    parentBrandIdentify: parentBrandIdentify || this.userInfo.brandIdentify,
                },
                orderBy: '',
                pageNum: 1,
                pageSize: 50
            }).then(res => {
                // console.log("子品牌列表",res)
                this.sonBrandOptions = res.list;

                if (this.operType === "save") {
                    this.formSave.brandList = [this.sonBrandOptions[this.sonBrandOptions.length-1].brandIdentify] || [];
                }
            })
        }, 
		// 获取角色下拉项
		getRoleList(brandIdentify) {
		    this.$api.roleSelect({
		        data: {
		            assistantResId: "",
		            brandId: "",
                    brandIdentify: brandIdentify || "",
		            createBy: "",
		            createTime: "",
		            createTimeFrom: "",
		            createTimeTo: "",
		            description: "",
		            isSelect: "",
		            parentRoleId: "",
		            roleId: "",
		            roleName: "",
		            state: ""
		        },
		        orderBy: '',
		        pageNum: 1,
		        pageSize: 50
		    }).then(res => {
		        // console.log("角色列表",res)
                let commonRoles = [],
                    brandRoles = [];
                for(let role of res.list){
                    if(['', null, undefined].includes(role.brandId)){
                        commonRoles.push(role);
                    }else{
                        brandRoles.push(role);
                    }
                } 
                this.roulelist = [{
                  label: '通用角色',
                  options: commonRoles
                },{
                  label: '自定义角色',
                  options: brandRoles
                }]
		    })
		},

        commit() {
            
            this.$refs.formSaveRef.validate((valid) => {
                if (valid) {
                    this.loading = true;
                    let queryData = Object.assign({},this.formSave);
                    delete queryData.ensurepassword;
                    this.$api.getUserSave(this.operType, {
                        ...queryData,
                        password: this.needPassword == true ? Encrypt(this.formSave.password) : '',
                    }).then(res => {
                        if(res.errcode != 0) return false;
                        this.$message.success(res.errmsg)
                        // 新建后弹窗禁止关闭
        				if(this.userInfo.brandIdentify == 'relx') {
        					this.dialogFormVisible = false;
        					this.resetFormData();
        				}

                        // 创建成功赋值id和品牌
                        this.current_row = res.data
                        //新增成功后改变titleUser和operType和修改密码开关
                        this.formSave = res.data
                        if (this.operType == 'update') {
                            this.dialogFormVisible = false;
                        }else{
                            this.operType = 'update';
                            this.formSave.password = '';
                            this.formSave.ensurepassword = '';
                            this.activeName = 'second';
                        }
                        this.$emit("requestList");
                    }).finally(()=>{
                        this.loading = false;
                    })
                } else {
                    return false;
                }
            });
        },
        // 取消按钮回调
        getCancelBtn() {
            this.resetFormData();
            this.$refs.formSaveRef.resetFields()
            this.dialogFormVisible = false;
            // this.$emit("requestList");
        },


        // 新增用户
        showAddUser(prantBrand){
            this.init();
            this.resetFormData();
            this.dialogFormVisible = true
            this.activeName = 'first'
            this.operType = "save"
            this.needPassword = true

            this.formSave.brandIdentify = prantBrand || this.userInfo.brandIdentify
            this.formSave.userType = '0'
        },
        // 修改用户
        editUser(param) {
			this.$api.roleUserRoleByUserId(param.userId).then(response => {
				this.init();
				this.resetFormData();
				this.dialogFormVisible = true
				this.activeName = 'first'
				this.operType = "update"
				this.needPassword = false
				this.formSave = Object.assign(this.formSave,param)
				this.formSave.password = null
				this.formSave.ensurepassword = ""
				this.current_row = param
				this.formSave.roleList = response.data?.roleList;
				this.formSave.groupList = response.data?.groupList;
			});
        },
        
        setFormState(){
            switch(this.operType){
                case "save":
                    this.titleUser = "新增用户"
                    this.needPassword = true
                    this.isPapulad = false
                    break;
                case "update":
                    this.titleUser = "修改用户"
                    this.needPassword = false
                    this.isPapulad = true
                    break;
                default:
                    return;
            }
        },
        resetFormData(){
            this.formSave = {
                account: "",
                agentCode: "",
                bossId: "",
                brandIdentify: "",
                brandList: [],
                contactInfo: "",
                createBy: "",
                createTime: "",
                email: "",
                ensurepassword: "",
                headImg: "",
                isDeleted: false,
                menuList: [],
                nickname: "",
				ppnUsername: "",
                password: "",
                roleList: [],
				groupList: [],
                state: "0",
                tsAccount: "",
                userId: "",
                userSite: "",
                userType: "",
                worktimeType: "",
            };
        },
	}
}
</script>